import { IconX } from "@tabler/icons-react";
import { CAMPOS_FILTRO_FACTURA, filtrosFacturaNoVacios, type FacturaFiltroKey, type FiltrosFactura } from "../utils/filtros-factura";

/** "2026-08-08" (formato del filtro/server) → "08/08/2026" para el chip. */
function valorLegible(valor: string): string {
  if (/^\d{4}-\d{2}-\d{2}$/.test(valor)) {
    const [y, m, d] = valor.split("-");
    return `${d}/${m}/${y}`;
  }
  return valor;
}

/**
 * Chips de los filtros por FACTURA activos · mismo estilo que `FiltrosActivos` (los de la
 * solicitud), con el prefijo «Factura» para distinguirlos aunque la fila esté colapsada.
 */
export function FiltrosFacturaActivos({
  filtros,
  onQuitar,
  onLimpiar,
}: {
  filtros: FiltrosFactura;
  onQuitar: (key: FacturaFiltroKey) => void;
  onLimpiar: () => void;
}) {
  const activos = filtrosFacturaNoVacios(filtros);
  const campos = CAMPOS_FILTRO_FACTURA.filter((c) => activos[c.key]);
  if (campos.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {campos.map((c) => (
        <button
          key={c.key}
          type="button"
          onClick={() => onQuitar(c.key)}
          aria-label={`Quitar filtro de factura ${c.label}: ${activos[c.key]}`}
          className="group inline-flex max-w-72 items-center gap-1 rounded-full border border-input bg-muted/40 py-0.5 pl-2.5 pr-1.5 text-xs text-foreground transition-colors hover:border-peligro-300 hover:bg-peligro-50 dark:hover:bg-peligro-900/20"
        >
          <span className="text-muted-foreground">Factura · {c.label}:</span>
          <span className="truncate font-medium">{valorLegible(activos[c.key]!)}</span>
          <IconX size={12} stroke={2} className="shrink-0 text-muted-foreground group-hover:text-peligro-600" />
        </button>
      ))}
      {campos.length > 1 && (
        <button type="button" onClick={onLimpiar} className="text-xs text-multiva-600 hover:underline">
          Limpiar filtros de factura
        </button>
      )}
    </div>
  );
}
